<template>
  <div class="m-currency-tips">
    <Header class="m-pc" :extras="extras" platform="pc"></Header>
    <div class="m-currency-content">
      <div class="m-exam-score">
        <img
          :style="{
            display:
              extraItem.extras('successImg.display') == 1 ? 'block' : 'none',
          }"
          :src="extraItem.extras('successImg.src')"
          alt=""
        />
        <div class="score-text-pc">您的得分：{{ score }}</div>
      </div>
      <div
        class="score-desc-pc"
        :style="{
          display:
            extraItem.extras('successText.display') == 1 ? 'block' : 'none',
          color: extraItem.extras('successText.color'),
          fontSize: pxOrVw(extraItem.extras('successText.size')),
          fontWeight:
            extraItem.extras('successText.weight') == 'default'
              ? '400'
              : extraItem.extras('successText.weight'),
        }"
      >
        {{
          extraItem.extras("successText.model") || "感谢您的参与，祝您工作愉快"
        }}
      </div>
      <div class="t-success-desc" v-if="hasJoin">
        再次填写，请点击这里<span class="u-again" @click="goIndex">→GO!</span>
      </div>
      <div
        v-if="answerId"
        class="m-icon-text u-result-view-pa"
        :style="{
          display:
            extraItem.extras('successBtn.display') == 1 ? 'block' : 'none',
        }"
      >
        <div
          class="u-result-view"
          @click="viewRsult"
          :style="{
            opacity: extraItem.extras('successBtn.opacity') / 100,
          }"
        >
          {{ extraItem.extras("successBtn.model") || "查看试卷答案" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import templateMixin from "../../../mixins/exam-random-config";
import successMixin from "../../../mixins/success";
import { URLS } from "fire-wind-water";
export default {
  name: "success",
  mixins: [templateMixin, successMixin],
  components: {
    Header,
  },
  data() {
    return {
      score: URLS.getHash("score") || 100,
      answerId: Number(URLS.getHash("answerId")),
      isSetting: Number(URLS.getURL("isSetting")),
      questionnaireId:
        URLS.getURL("questionaryId") || URLS.getHash("questionaryId"),
      hasJoin: 0,
    };
  },
  methods: {
    viewRsult() {
      if (this.isSetting) {
        return;
      }
      this.$router.push({ path: "result", query: this.$route.query });
    },
  },
};
</script>

<style scoped></style>
